<template>
    <div class="container">
        <div class="body">
            <div class="body-container f-s-b">
                <van-image 
                    class="body-image"
                    lazy-load
                    fit="contain"
                    :src="image"
                />
                <div class="body-title">支付成功</div>
                <div class="desc">
                    <span class="price g-b-500">150.00</span>
                    <span class="unit">元</span>
                </div>
                <div class="body-desc">我们讲尽快为您发货，请耐心等待！</div>
                <div class="btn-box f-s-b">
                    <div class="f-c back-home" v-touch:tap="routerPage('haibotang')">继续逛逛</div>
                    <div class="f-c look-qr" v-touch:tap="routerPage('personalCenter')">查看订单</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                image: require('@image/shopping/pay-success.png'),
            }
        },
        methods: {
            routerPage(name){
                return ()=> this.$router.push({ name })
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";

    .container{
        .body{
            position: relative;
            box-sizing: border-box;
            height: 100%;
            min-height: 506px;
            padding: 20px 7px;
            .body-container{
                justify-content: flex-start;
                box-sizing: border-box;
                flex-direction: column;
                padding: 35px 30px 0;
                width: 100%;
                height:100%;
                background:rgba(255,255,255,1);
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                border-radius:5px;
                .body-image{
                    width: 200px;
                    height: 175px;
                }
                .body-title{
                    margin-top: 30px;
                    font-size:18px;
                    font-weight:600;
                    color: #365C84;
                }
                .desc{
                    // margin-top: 6px;
                    margin: 18px 0;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(71,75,78,1);
                    .price{
                        color:#FF9824;
                        font-size: 18px;
                    }
                    .unit{
                        font-size: 14px;
                    }
                }
                .body-desc{
                    // margin-top: 6px;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(98,98,98,1);
                }
                .btn-box{
                    margin-top: 74px;
                    width: 100%;
                    .back-home{
                        color: #ffffff;
                        width:135px;
                        height:37px;
                        border-radius:5px;
                        // background:rgba(92,162,253,1);
                        background:linear-gradient(157deg,rgba(255,163,0,1) 0%,rgba(255,63,54,1) 100%);
                        // border:1px solid rgba(105,170,254,1);
                    }
                    .look-qr{
                        color: #626262;
                        width:135px;
                        height:37px;
                        // background:rgba(92,162,253,1);
                        background:rgba(237,237,237,1);
                        border-radius:5px;
                    }
                }
            }
        }
    }
</style>